import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN, AUTH_DETAILS, MENU_ITEMS } from "constants/AuthConstant";
import { notification } from "antd";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = "authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = "Bearer  " + jwtToken;
    }
    return config;
  },
  (error) => {
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: "",
    };
    if (unauthorizedCode.includes(error.response?.status)) {
      notificationParam.message = error.response?.data?.message || "Authentication Fail";
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(AUTH_DETAILS);
      localStorage.removeItem(MENU_ITEMS);
      store.dispatch(signOutSuccess());
    }

    if (error.response?.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response?.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response?.status === 508) {
      notificationParam.message = "Time Out";
    }

    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
